import { MetricCard } from './metric-card';
import { MetricConfig } from './metric-definitions';

interface Metric extends MetricConfig {}

interface MetricSectionProps {
  title: string;
  color: string;
  metrics: Metric[];
  className?: string;
}

export function MetricSection({ title, color, metrics, className }: MetricSectionProps) {
  // Only show metrics that have data
  const visibleMetrics = metrics.filter(metric => metric.value > 0);

  if (visibleMetrics.length === 0) {
    return null;
  }

  return (
    <div class={`${className || ''}`}>
      <div class="flex items-center mb-4">
        <div class={`w-1 h-8 bg-gradient-to-b ${color} rounded-full mr-4`}></div>
        <h2 class="text-lg font-semibold">{title}</h2>
      </div>
      
      <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4">
        {visibleMetrics.map((metric, index) => (
          <MetricCard
            key={index}
            label={metric.label}
            value={metric.value}
            icon={metric.icon}
          />
        ))}
      </div>
    </div>
  );
}
